export default __webpack_public_path__ + "static/media/gel-buffer-123.1c8a356c.svg";